import {
  DashboardOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';


import { faAddressCard, faCalendarDay, faDollarSign, faFileInvoiceDollar, faGaugeHigh, faInbox, faMapLocation, faMoneyCheckDollar, faRoute, faRulerTriangle, faScrewdriverWrench, faSquareDollar, faTruckClock, faUserHelmetSafety } from '@fortawesome/pro-light-svg-icons'

import { faMap, faObjectsColumn, faMessageLines, faLocationDot, faUser, faUserGroup, faChartLine, faTv, faAddressBook, faContactBook, faContactCard, faMagnifyingGlass, faBook, faBooks, faFiles, faBrowser, faList, faFolders, faFileImage } from '@fortawesome/pro-regular-svg-icons'

const dashBoardNavTree = [{
  key: 'overview',
  path: '/overview',
  title: 'app.nav.overview',
  icon: faObjectsColumn,
  breadcrumb: false,
  submenu: []
}, {
  key: 'notifications',
  path: '/notifications',
  title: 'app.nav.notifications',
  icon: faMessageLines,
  breadcrumb: false,
  submenu: []
}, {
  key: 'directory',
  path: '/directory',
  title: 'app.nav.directory',
  icon: faAddressBook,
  breadcrumb: false,
  submenu: [{
    key: 'contacts',
    path: '/contacts',
    title: 'app.nav.contacts',
    icon: faContactCard,
    breadcrumb: false,
    plan: 'pro',
    submenu: []
  }, {
    key: 'users',
    path: '/users',
    title: 'app.nav.users',
    icon: faUser,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'groups',
    path: '/groups',
    title: 'app.nav.groups',
    icon: faUserGroup,
    breadcrumb: false,
    submenu: []
  }
  ]
},
/*{
  key: 'locations',
  path: '/locations',
  title: 'app.nav.locations',
  icon: faLocationDot,
  breadcrumb: false,
  submenu: [] 
}, {
  key: 'displays',
  path: '/displays',
  title: 'app.nav.displays',
  icon: faTv,
  breadcrumb: false,
  submenu: []
}, 
*/
{
  key: 'resources',
  path: '/resources',
  title: 'app.nav.resources',
  icon: faBooks,
  breadcrumb: false,
  submenu: [{
    key: 'assets',
    path: '/assets',
    title: 'app.nav.assets',
    icon: faFileImage,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'documents',
    path: '/documents',
    title: 'app.nav.documents',
    icon: faFolders,
    breadcrumb: false,
    submenu: []
  },
  /* {
  { 
    key: 'forms',
    path: '/forms',
    title: 'app.nav.forms',
    icon: faList,
    breadcrumb: false,
    submenu: []
  }, { 
    key: 'maps',
    path: '/maps',
    title: 'app.nav.maps',
    icon: faMap,
    breadcrumb: false,
    submenu: []
  }, 
},*/
  {
    key: 'weblinks',
    path: '/web-links',
    title: 'app.nav.weblinks',
    icon: faBrowser,
    breadcrumb: false,
    submenu: []
  }
  ]
}, {
  key: 'reports',
  path: '/reports',
  title: 'app.nav.reports',
  icon: faChartLine,
  breadcrumb: false,
  submenu: []
},
  /*  {
    key: 'calendar',
    path: '/calendar',
    title: 'app.nav.schedule',
    icon: faMessageLines,
    breadcrumb: false,
    submenu: [{
      key: 'calendar',
      path: '/calendar',
      title: 'app.nav.calendar',
      icon: faCalendarDay,
      breadcrumb: false,
      submenu: []
    }, {
      key: 'dispatch',
      path: '/dispatch',
      title: 'app.nav.dispatch',
      icon: faTruckClock,
      breadcrumb: false,
      submenu: []
    }, {
      key: 'routes',
      path: '/routes',
      title: 'app.nav.routes',
      icon: faRoute,
      breadcrumb: false,
      submenu: []
    }
    ]
  }, {
    key: 'map',
    path: '/map',
    title: 'app.nav.map',
    icon: faLocationDot,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'clients',
    path: '/clients',
    title: 'app.nav.clients',
    icon: faAddressCard,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'requests',
    path: '/requests',
    title: 'app.nav.requests',
    icon: faInbox,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'quotes',
    path: '/quotes',
    title: 'app.nav.quotes',
    icon: faRulerTriangle,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'jobs',
    path: '/jobs',
    title: 'app.nav.jobs',
    icon: faScrewdriverWrench,
    breadcrumb: false,
    submenu: []
  }, {
    key: 'invoices',
    path: '/invoices',
    title: 'app.nav.invoices',
    icon: faFileInvoiceDollar,
    breadcrumb: false,
    submenu: []
  }
  */
]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
